import { getLocale, getDefaultLocale } from '../../services/localeSupport.service';
import { Translations } from '../translations/translations';

export const i18nextConfiguration = {
  interpolation: { escapevalue: false },
  lng: getLocale(),
  resources: Translations,
  fallbackLng: getDefaultLocale(),
}
